// extracted by mini-css-extract-plugin
export var box = "Modal-module--box--da758";
export var boxWrapper = "Modal-module--boxWrapper--d6d3a";
export var close = "Modal-module--close--bea59";
export var container = "Modal-module--container--5dec8";
export var dark = "Modal-module--dark--a7ff8";
export var light = "Modal-module--light--466bd";
export var overlay = "Modal-module--overlay--4ced1";